export default function BrandLogo({ size = 'md', className = '' }) {
  const sizes = {
    sm: 80,
    md: 80,
    lg: 170
  }
  return (
    <img
      src="/images/logo-tamkas.png"
      alt="TAMKAS"
      style={{ height: `${sizes[size]}px`, width: 'auto' }}
      className={`object-contain ${className}`}
    />
  )
}
